export default __webpack_public_path__ + "static/media/highlight-image-modal.9cb1fd6e.png";